module.exports = __webpack_public_path__ + "img/days_left_time_panel.b9a273db.png";